import React, { useEffect, useState } from "react";
import ikas from "../../providers/ikas";
import { BasketIcon, HeartIcon } from "@phosphor-icons/react";
import * as compSettings from "./settings";
import { useNavigate } from "react-router-dom";
import config from "../../config";
const SingleProduct = ({ id, extendedSettings, data, dataSetter }) => {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [quickBuyProduct, setQuickBuyProduct] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [quickBuyVisible, setQuickBuyVisible] = useState(false);
  const [quickBuyModalVisible, setQuickBuyModalVisible] = useState(false);
  const [quickBuyLoading, setQuickBuyLoading] = useState(false);
  const [quickBuyToast, setQuickBuyToast] = useState("");
  const [showQuickBuyToast, setShowQuickBuyToast] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [cartModalVisible, setCartModalVisible] = useState(false);

  // Settings'ten değerleri al
  const productId = JSON.parse(settings.product.value)[0].id;
  const containerBackgroundColor = settings.containerBackgroundColor.value;
  const cardBackgroundColor = settings.cardBackgroundColor.value;
  const cardBorderColor = settings.cardBorderColor.value;
  const cardShadowColor = settings.cardShadowColor.value;
  const productTitleColor = settings.productTitleColor.value;
  const priceColor = settings.priceColor.value;
  const oldPriceColor = settings.oldPriceColor.value;
  const discountBadgeColor = settings.discountBadgeColor.value;
  const discountTextColor = settings.discountTextColor.value;
  const iconColor = settings.iconColor.value;
  const iconBackgroundColor = settings.iconBackgroundColor.value;
  const favoriteIconColor = settings.favoriteIconColor.value;
  const loadingBackgroundColor = settings.loadingBackgroundColor.value;
  const imageBackgroundColor = settings.imageBackgroundColor.value;
  const unavailableOpacity = settings.unavailableOpacity.value;
  const containerPaddingX = settings.containerPaddingX.value + "px";
  const containerPaddingY = settings.containerPaddingY.value + "px";
  const cardPadding = settings.cardPadding.value + "px";
  const cardBorderRadius = settings.cardBorderRadius.value + "px";
  const cardBorderWidth = settings.cardBorderWidth.value + "px";
  const imageHeight = settings.imageHeight.value + "px";
  const imageBorderRadius = settings.imageBorderRadius.value + "px";
  const imageMarginBottom = settings.imageMarginBottom.value + "px";
  const productTitleFontSize = settings.productTitleFontSize.value + "px";
  const productTitleFontWeight = settings.productTitleFontWeight.value;
  const productTitleMarginBottom =
    settings.productTitleMarginBottom.value + "px";
  const productTitleMinHeight = settings.productTitleMinHeight.value + "px";
  const productTitleLineClamp = settings.productTitleLineClamp.value;
  const priceFontSize = settings.priceFontSize.value + "px";
  const priceFontWeight = settings.priceFontWeight.value;
  const oldPriceFontSize = settings.oldPriceFontSize.value + "px";
  const discountFontSize = settings.discountFontSize.value + "px";
  const discountFontWeight = settings.discountFontWeight.value;
  const iconSize = settings.iconSize.value;
  const iconPadding = settings.iconPadding.value + "px";
  const iconBorderRadius = settings.iconBorderRadius.value + "%";
  const iconPositionTop = settings.iconPositionTop.value + "px";
  const iconPositionSide = settings.iconPositionSide.value + "px";
  const shadowBlur = settings.shadowBlur.value + "px";
  const shadowOffsetY = settings.shadowOffsetY.value + "px";
  const maxWidth = settings.maxWidth.value;
  const showShadow = settings.showShadow.value;
  const showBorder = settings.showBorder.value;
  const showDiscountBadge = settings.showDiscountBadge.value;
  const showFavoriteIcon = settings.showFavoriteIcon.value;
  const showCartIcon = settings.showCartIcon.value;
  const showOldPrice = settings.showOldPrice.value;
  const clickableCard = settings.clickableCard.value;
  const loadingAnimation = settings.loadingAnimation.value;
  const imageObjectFit = settings.imageObjectFit.value;
  const pricePosition = settings.pricePosition.value;
  const titleTextAlign = settings.titleTextAlign.value;
  const hoverEffects = settings.hoverEffects.value;
  const hoverScale = settings.hoverScale.value;
  

  const navigation = useNavigate();

  useEffect(() => {
    const fetchProduct = async () => {
      if (!productId) return;
      setLoading(true);
      try {
        const input = {
          productIdList: [productId],
          page: 1,
          perPage: 20,
        };
        const data = await ikas.searchProducts(input);
        const result = data.results[0];
        setProduct(result);
      } catch (err) {
        setProduct(null);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [productId]);

  if (loading && loadingAnimation) {
    return (
      <div
        style={{
          width: "100%",
          paddingLeft: containerPaddingX,
          paddingRight: containerPaddingX,
          paddingTop: containerPaddingY,
          paddingBottom: containerPaddingY,
          backgroundColor: containerBackgroundColor,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: cardBackgroundColor,
            borderRadius: cardBorderRadius,
            boxShadow: showShadow
              ? `0 ${shadowOffsetY} ${shadowBlur} ${cardShadowColor}`
              : "none",
            width: "100%",
            maxWidth: maxWidth > 0 ? maxWidth + "px" : "none",
            border: showBorder
              ? `${cardBorderWidth} solid ${cardBorderColor}`
              : "none",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "4px",
              paddingLeft: cardPadding,
              paddingRight: cardPadding,
              paddingTop: cardPadding,
            }}
          >
            <div
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: loadingBackgroundColor,
                borderRadius: "50%",
              }}
            />
            <div
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: loadingBackgroundColor,
                borderRadius: "50%",
              }}
            />
          </div>
          <div
            style={{
              width: "100%",
              height: imageHeight,
              backgroundColor: loadingBackgroundColor,
              marginBottom: imageMarginBottom,
              borderTopLeftRadius: cardBorderRadius,
              borderTopRightRadius: cardBorderRadius,
            }}
          />
          <div
            style={{
              height: "16px",
              backgroundColor: loadingBackgroundColor,
              borderRadius: "4px",
              marginBottom: productTitleMarginBottom,
              width: "83.33%",
              marginLeft: cardPadding,
              marginRight: cardPadding,
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "4px",
              gap: "4px",
              marginLeft: cardPadding,
              marginRight: cardPadding,
            }}
          >
            <div
              style={{
                height: "16px",
                backgroundColor: loadingBackgroundColor,
                borderRadius: "4px",
                width: "50%",
              }}
            />
            <div
              style={{
                height: "16px",
                backgroundColor: loadingBackgroundColor,
                borderRadius: "4px",
                width: "66.67%",
              }}
            />
          </div>
          <div
            style={{
              height: "20px",
              backgroundColor: loadingBackgroundColor,
              borderRadius: "4px",
              width: "50%",
              margin: "0 auto",
              marginTop: "8px",
              marginBottom: cardPadding,
            }}
          />
        </div>
      </div>
    );
  }
  if (!product) return null;

  const variant = product.variants?.[0];
  const imageUrl = `https://cdn.myikas.com/images/${config.MERCHANT_ID}/${variant?.images?.[0]?.id}/image_540.webp`;
  const prices = variant?.prices?.[0]; //TODO:priceListId'ye göre seç
  const discount = prices?.discountPrice
    ? "%" +
      Number(
        ((prices?.sellPrice - prices?.discountPrice) / prices?.sellPrice) * 100
      ).toFixed(0) +
      " İNDİRİM"
    : "";
  const selectedTotalStock = variant?.stocks?.reduce(
    (totalValue, currentValue) => {
      return totalValue + currentValue.stockCount;
    },
    0
  );
  const isAvailable = selectedTotalStock > 0 || variant?.availableForSale;
  const isFavorite = data.favorites.includes(product.id);

  const getBoxShadow = () => {
    if (!showShadow) return "none";
    return `0 ${shadowOffsetY} ${shadowBlur} ${cardShadowColor}`;
  };

  const getTransform = () => {
    if (!hoverEffects || !isHovered) return "none";
    return `scale(${hoverScale})`;
  };
  const onWishlistIconClick = (product) => {
    let newFavorites = [...data.favorites];
    if (data?.favorites?.includes(product.id)) {
      newFavorites = data.favorites.filter((id) => id !== product.id);
    } else {
      newFavorites.push(product.id);
    }
    dataSetter({
      key: "favorites",
      value: newFavorites,
    });
    localStorage.setItem("favorites", JSON.stringify(newFavorites));
  };

  const handleCardClick = () => {
    if (clickableCard && onProductClick) {
      onProductClick(product);
    }
  };

  const onProductClick = (product) => {
    navigation(`/product`, {
      state: product,
    });
  };
  const onCartIconClick = (product) => {
    let productVariantsHashMap = {};
    product.variants.forEach((variant) => {
      let key = "";
      variant.variantValues.forEach((vv) => {
        key += vv.variantTypeId + vv.variantValueId + "/";
      });
      if (key.endsWith("/")) key = key.slice(0, -1);
      productVariantsHashMap[key] = { ...variant, key };
    });
    const firstVariantKey = Object.keys(productVariantsHashMap)[0];
    const firstVariant = productVariantsHashMap[firstVariantKey];
    setSelectedVariant(firstVariant);
    setQuickBuyProduct({ ...product, variantMap: productVariantsHashMap });
    setQuickBuyVisible(true);
    setTimeout(() => setQuickBuyModalVisible(true), 10);
  };
  const handleCartClick = (e) => {
    e.stopPropagation();

    onCartIconClick(product);
  };

  return (
    <div>
      <div
        style={{
          width: "100%",
          paddingLeft: containerPaddingX,
          paddingRight: containerPaddingX,
          paddingTop: containerPaddingY,
          paddingBottom: containerPaddingY,
          backgroundColor: containerBackgroundColor,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: cardBackgroundColor,
            borderRadius: cardBorderRadius,
            boxShadow: getBoxShadow(),
            width: "100%",
            maxWidth: maxWidth > 0 ? maxWidth + "px" : "none",
            border: showBorder
              ? `${cardBorderWidth} solid ${cardBorderColor}`
              : "none",
            position: "relative",
            opacity: isAvailable ? "1" : unavailableOpacity,
            cursor: clickableCard ? "pointer" : "default",
            transform: getTransform(),
            transition: hoverEffects ? "all 0.2s ease" : "none",
            margin: "0 auto",
          }}
          onClick={handleCardClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div
            style={{
              position: "absolute",
              top: iconPositionTop,
              right: iconPositionSide,
              left: iconPositionSide,
              display: "flex",
              justifyContent: "space-between",
              zIndex: 10,
            }}
          >
            {showCartIcon && (
              <button
                style={{
                  color: iconColor,
                  backgroundColor: iconBackgroundColor,
                  borderRadius: iconBorderRadius,
                  padding: iconPadding,
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={handleCartClick}
              >
                <BasketIcon color={iconColor} size={iconSize} />
              </button>
            )}
            {showFavoriteIcon && (
              <button
                style={{
                  color: iconColor,
                  backgroundColor: iconBackgroundColor,
                  borderRadius: iconBorderRadius,
                  padding: iconPadding,
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onWishlistIconClick(product);
                }}
              >
                <HeartIcon
                  color={isFavorite ? favoriteIconColor : iconColor}
                  size={iconSize}
                  weight={isFavorite ? "fill" : "regular"}
                />
              </button>
            )}
          </div>
          <img
            src={imageUrl}
            alt={product.name}
            style={{
              width: "100%",
              height: imageHeight,
              objectFit: imageObjectFit,
              marginBottom: imageMarginBottom,
              backgroundColor: imageBackgroundColor,

              borderRadius: imageBorderRadius,
            }}
            draggable={false}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: cardPadding,
              paddingRight: cardPadding,
              paddingBottom: cardPadding,
            }}
          >
            <div
              style={{
                fontWeight: productTitleFontWeight,
                color: productTitleColor,
                fontSize: productTitleFontSize,
                marginBottom: productTitleMarginBottom,
                minHeight: productTitleMinHeight,
                textAlign: titleTextAlign,
                display: "-webkit-box",
                WebkitLineClamp: productTitleLineClamp,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {product.name}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems:
                  pricePosition === "center"
                    ? "center"
                    : pricePosition === "right"
                    ? "flex-end"
                    : "flex-start",
              }}
            >
              {showOldPrice && prices?.discountPrice && (
                <span
                  style={{
                    color: oldPriceColor,
                    fontSize: oldPriceFontSize,
                    textDecoration: "line-through",
                  }}
                >
                  ₺
                  {parseFloat(prices?.sellPrice).toLocaleString("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              )}
              <span
                style={{
                  color: priceColor,
                  fontSize: priceFontSize,
                  fontWeight: priceFontWeight,
                }}
              >
                ₺
                {parseFloat(
                  prices?.discountPrice ?? prices?.sellPrice
                ).toLocaleString("tr-TR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>
          {showDiscountBadge && discount && (
            <div
              style={{
                backgroundColor: discountBadgeColor,
                color: discountTextColor,
                fontSize: discountFontSize,
                fontWeight: discountFontWeight,
                borderBottomLeftRadius: cardBorderRadius,
                borderBottomRightRadius: cardBorderRadius,
                paddingLeft: cardPadding,
                paddingRight: cardPadding,
                paddingTop: "4px",
                paddingBottom: "4px",
                textAlign: "center",
                width: "100%",
              }}
            >
              {discount}
            </div>
          )}
        </div>
      </div>
      {/* Quick Buy Modal */}
      {quickBuyVisible && quickBuyProduct && (
        <div
          className="fixed inset-0 z-[200] flex flex-col justify-end bg-black bg-opacity-40"
          onClick={() => {
            setQuickBuyModalVisible(false);
            setTimeout(() => setQuickBuyVisible(false), 300);
          }}
        >
          <div
            className={`w-full bg-white rounded-t-2xl shadow-lg py-6  relative transition-all duration-300 ${
              quickBuyModalVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-full opacity-0"
            }`}
            style={{ minHeight: 200 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute top-3 right-3 flex gap-2">
              <button
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-black text-2xl"
                onClick={() => {
                  setQuickBuyModalVisible(false);
                  setTimeout(() => setQuickBuyVisible(false), 300);
                }}
                aria-label="Kapat"
              >
                ×
              </button>
            </div>
            <div className="flex items-center px-6 pt-1 pb-4 gap-4">
              <img
                src={`https://cdn.myikas.com/images/${config.MERCHANT_ID}/${quickBuyProduct.variants?.[0]?.images?.[0]?.id}/image_540.webp`}
                alt={quickBuyProduct.name}
                style={{
                  width: 80,
                  height: 80,
                  objectFit: "cover",
                  borderRadius: 12,
                  backgroundColor: "#f9fafb",
                }}
                draggable={false}
              />
              <div>
                <div className="font-bold text-lg">{quickBuyProduct.name}</div>
                {selectedVariant?.selectedOptions?.map((option) => (
                  <div key={option.name} className="text-sm text-gray-700">
                    {option.name}: {option.value}
                  </div>
                ))}
                <div className="mt-2">
                  {(() => {
                    const prices = selectedVariant?.prices?.[0];
                    return prices ? (
                      <>
                        {prices.discountPrice && (
                          <span className="text-red-500 font-semibold mr-2">
                            {prices.sellPrice} TL
                          </span>
                        )}
                        {prices.discountPrice && (
                          <span className="text-gray-500 line-through mr-2">
                            {prices.discountPrice} TL
                          </span>
                        )}
                        {!prices.discountPrice && (
                          <span className="text-black font-semibold">
                            {prices.sellPrice} TL
                          </span>
                        )}
                      </>
                    ) : null;
                  })()}
                </div>
                <div className="mt-1 text-xs text-gray-500">
                  {(() => {
                    const stock = selectedVariant?.stocks?.reduce(
                      (t, c) => t + c.stockCount,
                      0
                    );
                    return stock > 0 || selectedVariant?.availableForSale
                      ? "Stokta"
                      : "Stokta yok";
                  })()}
                </div>
              </div>
            </div>
            {/* Varyant Seçici */}
            <div className="px-6 pb-4">
              {quickBuyProduct.productVariantTypes?.map(
                ({ variantType }, index) => {
                  return (
                    variantType.values.length > 1 && (
                      <div key={index} className="mb-4">
                        <div className="grid grid-cols-4 gap-3">
                          {variantType.values.map((value) => {
                            // Hashmap key oluştur
                            const key = quickBuyProduct.productVariantTypes
                              .map((vt, i) =>
                                i === index
                                  ? vt.variantType.id + value.id
                                  : vt.variantType.id +
                                    (selectedVariant?.variantValues?.find(
                                      (vv) =>
                                        vv.variantTypeId === vt.variantType.id
                                    )?.variantValueId ||
                                      vt.variantType.values[0].id)
                              )
                              .join("/");
                            const variantObj =
                              quickBuyProduct.variantMap?.[key];
                            const isAvailable = variantObj?.availableForSale;
                            const isSel = selectedVariant?.key === key;
                            return (
                              <button
                                key={value.id}
                                onClick={() => {
                                  if (isAvailable)
                                    setSelectedVariant(variantObj);
                                }}
                                disabled={!isAvailable}
                                className={`h-12 rounded text-sm font-medium transition-colors duration-200 ${
                                  isSel
                                    ? "bg-black text-white"
                                    : "bg-gray-100 text-black hover:bg-gray-200"
                                } ${
                                  !isAvailable
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                              >
                                {value.name}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )
                  );
                }
              )}
            </div>
            {/* Sepete Ekle Butonu */}
            <div className="px-6 pb-2">
              <button
                className="w-full bg-black text-white py-3 rounded-sm text-base font-bold"
                disabled={quickBuyLoading}
                onClick={async () => {
                  const cartId =
                    localStorage.getItem("cartId") ??
                    sessionStorage.getItem("cartId");
                  setQuickBuyLoading(true);
                  try {
                    const input = {
                      cartId,
                      salesChannelId: config.SALES_CHANNEL_ID,
                      storefrontThemeId: config.ROUTING_ID,
                      item: {
                        quantity: 1,
                        variant: {
                          id: selectedVariant.id,
                          name: quickBuyProduct.name,
                        },
                      },
                    };

                    const addResult = await ikas.addItemToCart(input);

                    dataSetter(addResult);
                    setShowCartModal(true);
                    setTimeout(() => setCartModalVisible(true), 10);
                    setQuickBuyModalVisible(false);
                    setTimeout(() => setQuickBuyVisible(false), 300);
                  } catch (err) {
                    console.error(err);
                    setQuickBuyToast("Bir hata oluştu");
                    setShowQuickBuyToast(true);
                    setTimeout(() => setShowQuickBuyToast(false), 1500);
                  } finally {
                    setQuickBuyLoading(false);
                  }
                }}
              >
                Sepete Ekle
              </button>
            </div>
            {/* Toast */}
            {showQuickBuyToast && (
              <div className="fixed bottom-24 left-1/2 -translate-x-1/2 bg-black text-white px-4 py-2 rounded shadow-lg z-[201]">
                {quickBuyToast}
              </div>
            )}
          </div>
        </div>
      )}
      {/* Cart confirmation modal */}
      {showCartModal && selectedVariant && quickBuyProduct && (
        <div className="fixed inset-0 z-[300] flex flex-col justify-end bg-black bg-opacity-40">
          <div
            className={`w-full bg-white rounded-t-2xl shadow-lg py-6 px-4 flex flex-row items-center relative transition-all duration-300 ${
              cartModalVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-full opacity-0"
            }`}
            style={{ minHeight: 160 }}
          >
            <button
              className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-black text-2xl"
              onClick={() => {
                setCartModalVisible(false);
                setTimeout(() => setShowCartModal(false), 300);
              }}
              aria-label="Kapat"
            >
              ×
            </button>
            <img
              src={`https://cdn.myikas.com/images/${config.MERCHANT_ID}/${selectedVariant?.images?.[0]?.id}/image_540.webp`}
              alt={quickBuyProduct.title}
              className="w-20 h-20 object-contain rounded mr-4 flex-shrink-0"
            />
            <div className="flex flex-col flex-1 items-start">
              <div className="text-green-600 font-bold text-lg mb-1">
                Product Added
              </div>
              <div className="font-semibold text-sm mb-3">
                {quickBuyProduct.title}
                {selectedVariant.title &&
                  selectedVariant.title !== "Default Title" && (
                    <>
                      :{" "}
                      <span className="font-normal">
                        {selectedVariant.title}
                      </span>
                    </>
                  )}
              </div>
              <button
                className="w-full bg-black text-white py-2 rounded-lg font-bold mb-2"
                onClick={() => {
                  setCartModalVisible(false);
                  setTimeout(() => setShowCartModal(false), 300);
                  navigation("/cart");
                }}
              >
                Go to cart
              </button>
              <button
                className="w-full bg-gray-100 text-black py-2 rounded-lg font-semibold"
                onClick={() => {
                  setCartModalVisible(false);
                  setTimeout(() => setShowCartModal(false), 300);
                }}
              >
                Continue shopping
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleProduct;
